import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import SignaturePad from 'react-signature-pad-wrapper'
import {

  SHOWIODFILE_URL,
  STOCKITEMS_BASE_URL,
  USERS_BASE_URL,


} from '../config';
import axios from 'axios';


// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import ClubHeader from './ClubHeader';



// Hook
import useAuth from '../hooks/useAuth';

import { useUserFetch } from '../hooks/useUserFetch';
import { useEmployeeListFetch } from '../hooks/useEmployeeList';
// Image

import Grid from './Grid';
import Display from './Display';
import PdfComp from './PdfComp';
import Sidepanel from './SidePanel';
import NoImage from '../images/no-image.png';




const User = () => {



  const auth = useAuth();
  const { id } = useParams()
  const location = useLocation();
  console.log(id)
  const { userstate, userloading, usererror, usersetLoading, usersetTrigger } = useUserFetch(id);
  const { state, loading, error, setSearchValue, setIncludeInactive, setLoading, setTrigger } = useEmployeeListFetch();
  const [pdffile, setPdfFile] = useState(null)
  const [edit, setEdit] = useState(false)
  const from = location.state?.from || "./";
  console.log("from = " + from)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [contractsOpen, setContractsOpen] = useState(false)
  const [idOpen, setIdOpen] = useState(false)
  const [otherOpen, setOtherOpen] = useState(false)
  const navigate = useNavigate()
  const form = useForm()
  const { register, control, handleSubmit, formState } = form
  const { errors } = formState
  const [errMessage, setErrMessage] = useState("");
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
  // console.log(besluit.besluit[0].besluit)
  console.log(userstate)
  console.log(location.state)
  console.log(state)


  const handleEdit = () => {
    setEdit((prev) => !prev)
  }
  const onSubmit = async (data) => {

    console.log(data)
    const transformedData = {
      ...data,
      employeeProfile: data.employeeProfile === "" ? null : data.employeeProfile
    }
    console.log(transformedData)
    try {
      const response = await axios.patch(`${USERS_BASE_URL}/${id}`,
        JSON.stringify({ data: transformedData }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


      console.log(response)
      setEdit(false)
      setErrMessage("")
      usersetTrigger(true)

    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.status === 500) {
        console.log(error.message)
        setErrMessage(error.message + " " + error.response?.data?.msg?.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }

  }
  const showFile = async (filename) => {

    console.log("show File gekliek")
    console.log(filename)

    console.log(auth.auth.accessToken)



    const response = await axios.get(SHOWIODFILE_URL + "/" + id + "/" + filename,
      {
        headers: {

          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + auth.auth.accessToken
        },
        responseType: 'blob'
      }

    );
    console.log(response)

    if (response.status !== 200) {
      throw new Error("response not ok")
    }

    const contentType = response.headers['content-type']; // E.g., "image/jpeg"
    console.log("Content-Type:", contentType);

    // Determine the file extension
    let extension = '';
    if (contentType === 'image/jpg') extension = '.jpg';
    else if (contentType === 'application/pdf') extension = '.pdf';
    else if (contentType === 'image/png') extension = '.png';
    else extension = ''; // Default to no extension if unknown

    const fileName = (state?.name || "downloaded-file") + extension;


    const blob = response.data;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Name of the file to be downloaded
    link.click();

  }
  return (
    <>

      <Header username={username} role={access} destination={from}></Header>
      <div className='employeeBody'>
        <Sidepanel open={sidebarOpen}>
          <div onClick={() => setSidebarOpen((prev) => !prev)}>{sidebarOpen ? "Close" : "Open"}</div>

        </Sidepanel>


        <Grid
          header={`${userstate?.givname + " " + userstate?.surname}`}

        >
          <div >
            <img
              src={userstate.imageUrl ? userstate.imageUrl : NoImage}
              alt={userstate.name}
              className="Avatar"

            />
          </div>
          {!edit ?
            (<>
              <Knoppie
                text={"Edit profile"}
                callback={handleEdit}
              ></Knoppie>

              <div>
                <div className='Lineitem'>
                  <div>username:</div><div>{userstate.username}</div>
                </div>
                <div className='Lineitem'>
                  <div>email:</div><div>{userstate.emailaddress}</div>
                </div>
                <div className='Lineitem'>
                  <div>group:</div><div>{userstate.group}</div>
                </div>
                <div className='Lineitem'>
                  <div>Department:</div><div>{userstate.dept}</div>
                </div>
                <div className='Lineitem'>
                  <div>Role:</div><div>{userstate.userRole}</div>
                </div>
                <div className='Lineitem'>
                  <div>Name:</div><div>{userstate.givname}</div>
                </div>
                <div className='Lineitem'>
                  <div>Surname:</div><div>{userstate.surname}</div>
                </div>
                <div className='Lineitem'>
                  <div>phone:</div><div>{userstate.phone}</div>
                </div>
                <div className='Lineitem'>
                  <div>employeeProfile:</div><div>{userstate.employeeProfile}</div>
                </div>

              </div>





              {/* key={userstate._id}
                employee={userstate.employee}
                group={userstate.group}

                dept={userstate.dept}
                title={userstate.title}

                givname={userstate.givname}
                surname={userstate.surname}
                adr1={userstate.adr1}
                adr2={userstate.adr2}
                adr3={userstate.adr3}
                pcode={userstate.pcode}
                phone={userstate.phone}
                sdate={userstate.sdate}
                baserate={userstate.baserate}
                holrule={userstate.holrule}
                sicrule={userstate.sicrule}
                holavail={userstate.holavail}
                leaveDates={""}
                termdate={userstate.termdate}
                position={userstate.position}
                identity={userstate.identity}
                incometax={userstate.incometax}
                dob={userstate.dob}
                active={userstate.active}
                normalHours={userstate.normalHours}
                gender={userstate.EEA1?.gender}
                race={userstate.EEA1?.race}
                disability={userstate.EEA1?.disability?.toString()}
                foreignNational={userstate.EEA1?.foreignNational?.toString()}
                injuryOnDuty={userstate.injuryOnDuty}
                IDOnFile={userstate.IDOnFile}
                emailaddress={userstate.emailaddress}

                id={userstate._id}
                edit={edit} */}


            </>
            )
            :
            (<>
              <Knoppie
                text={"Cancel"}
                callback={handleEdit}
              ></Knoppie>





              {errMessage !== "" ? <div>{errMessage}</div> : ""}

              <form onSubmit={handleSubmit(onSubmit)}>
                <button>Submit</button>

                <div className='Lineitem'>
                  <label>username</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.username}{...register('username', {
                    required: 'employee username is required'
                  })} />
                </div>
                {errors.username ? <p className='error'>{errors.user?.username}</p> : ""}

                <div className='Lineitem'>
                  <label>email</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.emailaddress} {...register('emailaddress', {
                    required: 'email is required',
                    pattern: {
                      value: /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
                      message: "email validation failed"
                    }
                  })} />
                </div>
                {errors.emailaddress ? <p className='error'>{errors.user?.emailaddress}</p> : ""}
                <div className='Lineitem'>
                  <label>group</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.group}{...register('group', {
                    required: 'group is required'
                  })} />
                </div>
                {errors.group ? <p className='error'>{errors.group?.message}</p> : ""}
                <div className='Lineitem'>
                  <label>Department</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.dept}{...register('dept')} />

                </div>
                <div className='Lineitem'>
                  <label>Role</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.userRole} {...register('userRole')} />

                </div>
                <div className='Lineitem'>
                  <label>Name</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.givname}{...register('givname')} />

                </div>
                <div className='Lineitem'>
                  <label>Surname</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.surname}{...register('surname')} />

                </div>
                <div className='Lineitem'>
                  <label>phone</label>
                  <input className="inputsize" type={"text"} defaultValue={userstate.phone}{...register('phone')} />

                </div>
                <div className='Lineitem'>
                  <label>Linked Employee Profile </label>
                  <select
                    className="inputsize"
                    {...register('employeeProfile', {})}
                    defaultValue={userstate.employeeProfile}
                  >
                    <option value="">Select an Employee</option> {/* Default option */}

                    {state?.employees?.map((employee) => (
                      <option key={employee._id} value={employee._id} >
                        {employee.employee + employee.givname+employee.surname}
                      </option>
                    ))}
                  </select>
                  <p className='error'>{errors.employee?.message}</p>
                </div>


              </form>
            </>
            )

          }





        </Grid>
      </div >


    </>
  );
};

export default User;

